/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_VisitInputs */

const en_directory_launch_visit = /** @type {(inputs: Directory_Launch_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit`)
};

const zh_directory_launch_visit = /** @type {(inputs: Directory_Launch_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问`)
};

/**
* | output |
* | --- |
* | "Visit" |
*
* @param {Directory_Launch_VisitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_visit = /** @type {((inputs?: Directory_Launch_VisitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_VisitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_visit(inputs)
	return zh_directory_launch_visit(inputs)
});
export { directory_launch_visit as "directory.launch.visit" }